// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/context-popup","trigger":"context-popup-m__trigger__3A_JZ"};